module.exports = __webpack_public_path__ + "fonts/avenir_light.33f6570a.ttf";